import { getSafeStoreInfoRequestContext } from '../context';
import { STORE_TYPE_BITRIX, STORE_TYPE_LITE, STORE_TYPE_YCP } from './constants';
import { type NonEmptyStoreTypes, type StoreType } from './types';

/**
 * Определяет, принадлежит ли текущий `StoreInfoRequestContext.type` к списку допустимых `types`.
 *
 * @param types - Непустой список допустимых `store_type`.
 * @returns `true`, если текущий `type` есть в `types`.
 * @kind helper
 */
export function checkStoreType(types: NonEmptyStoreTypes): boolean {
    const { type } = getSafeStoreInfoRequestContext();

    return (types as readonly StoreType[]).includes(type);
}

/**
 * Проверяет, является ли текущий магазин магазином Kit Lite.
 *
 * @returns Признак магазина Kit Lite.
 * @kind helper
 */
export function checkIsLiteStore(): boolean {
    return checkStoreType([STORE_TYPE_LITE]);
}

/**
 * Проверяет, не является ли текущий магазин магазином Kit Lite.
 *
 * @returns Признак не магазина Kit Lite.
 * @kind helper
 */
export function checkIsNotLiteStore(): boolean {
    return !checkIsLiteStore();
}

/**
 * Проверяет, является ли текущий магазин магазином Bitrix.
 *
 * @returns Признак магазина Bitrix.
 * @kind helper
 */
export function checkIsBitrixStore(): boolean {
    return checkStoreType([STORE_TYPE_BITRIX]);
}

/**
 * Проверяет, является ли текущий магазин магазином YCP.
 *
 * @returns Признак магазина YCP.
 * @kind helper
 */
export function checkIsYCPStore(): boolean {
    return checkStoreType([STORE_TYPE_YCP]);
}
